import { NgClass } from "@angular/common";
import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { IconComponent } from "@claas/claas-ui-components";

@Component({
  selector: "claas-argument-rating-icon",
  imports: [IconComponent, NgClass],
  templateUrl: "./argument-rating-icon.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./argument-rating-icon.scss",
})
export class ArgumentRatingIcon {
  rating = input<number>();
}
